
<div class="ui modal" id="Payout_Limit_Modal">

  <div class="header" style="background-color:#DCDCDC">
    <span tkey="INFO"></span>
    <button style="float:right;background-color: white;border: 1px solid;" class="circular ui icon button" (click)="Payout_Limit_Modal_Close()">
      <i class="remove link icon"></i>
    </button>
  </div>

  <div class="content" style="height:180px;">
    <span tkey="Payout_Modal_Desc" style="font-size: 18px;"></span>
  </div>
</div>